import React, { useState } from "react";

import { get } from "lodash";
import { getIcon } from "../../../../helpers/icons";
import { dateTime } from "../../../../helpers/date";
import Link from "../../../../components/Link";
import Title from "../../../../components/Title";
import AsyncGet from "../../../../components/AsyncGet";
import CardImage from "../../../../assets/image/creditCard.png";
import DialogBox from "../../../../components/DialogBox";
import PaymentHistory from "../../../../components/DialogBox/PaymentHistory";

import style from "../style.module.css";

export default function PaymentDetails(props) {
    const {
        userProfile = {}
    } = props;

    const [popup, setPopup] = useState(false);

    return (
        <>
        <div className={`${style.cardItem} ${style.paymentDetails}`}>
            <div className={style.cardItemHeader}>
                <Title className="fontTeko" tag="p" transform="uppercase">Payment details</Title>
            </div>
            <div className={style.cardItemBody}>
                <div className={style.cardItemtBodyInner}>
                    <Title className="fontTeko" tag="h5" transform="uppercase">Payment information</Title>
                    {
                        get(userProfile, 'membership.duration', '') !== "" && (
                            <>
                            <Title tag="p">Next payment, {dateTime(get(userProfile, 'membership.duration', ''), "MMM DD, Y")}</Title>
                            <AsyncGet
                                url="/payment/method"
                                permissionText="Method Change"
                                loadOnMount={true}
                                render={({ data, fetching }) => {
                                    if(fetching) {
                                        return (
                                            <div className={style.card}>
                                                <img alt="card_image" src={CardImage} />
                                                <Title tag="p"><span>**** **** **** ****</span></Title>
                                            </div>
                                        )
                                    }
                                    if(data) {
                                        return (
                                            <div className={style.card}>
                                                <img alt="card_image" src={CardImage} />
                                                <Title tag="p"><span>**** **** ****</span> {get(data, 'card.last4', '')}</Title>
                                            </div>
                                        )
                                    }
                                }}
                            />
                            </>
                        )
                    }
                    {
                        get(userProfile, 'expired.auto_renewal', 0) === 1 && (
                            <div className={style.autoRewel}>
                                <Title tag="p">Your subscription will renew automatically. You can cancel anytime.</Title>
                            </div>
                        )
                    }
                    {
                        get(userProfile, "membership.membership_id", "") !== "" && (
                            <div className={style.bigButton}>
                                <Link to="change-payment-method">Manage payment method <span><i className={getIcon('Chevronright')}></i></span></Link>
                            </div>
                        )
                    }
                    <div className={style.bigBtn} onClick={() => { setPopup('paymentHistory') }}>
                        View payment history <span><i className={getIcon('Chevronright')}></i></span>
                    </div>
                </div>
            </div>
        </div>
        {
                popup === "paymentHistory" && (
                    <DialogBox
                        onClose={() => setPopup(false)}
                        className={`${style.articlePopup}`}
                        title={false}
                        headerClass={style.dialogBoxHeader}
                        modalClassName={style.articleModal}
                        buttonClassName={style.customCloseStyle}
                        hasCloseIcon={false}
                        render={({ closeDialog }) => {
                            return (
                                <PaymentHistory
                                    closeDialog={closeDialog}
                                />
                            )
                        }}
                    />
                )
            }
        </>
    )
}